<div class="text-center flex flex-col p-4">
    <div class="flex flex-col items-center">
        <img src="https://storage.googleapis.com/komerce/assets/icons/popup-warning.png" alt="warning" width="100px">
        <div class="title mt-3 text-lg">Your previous top-up isn’t complete yet</div>
    </div>
    <span class="mt-3 text-grey">
        Please complete the payment to continue
    </span>
    <div class="flex w-full mt-3 gap-2">
        <button class="btn btn-outline-primary w-1/2" (click)="handleCancel()">Cancel Payment</button>
        <button class="btn btn-primary text-white w-1/2" (click)="handleCheckStatus()">Pay Now</button>
    </div>
</div>
